<script setup>
import {computed, onMounted, watch} from 'vue';
import {
    searchType,
    changeSearchType,
    checkboxs,
    checkList,
    checkAll,
    handleCheckAllChange,
    handleCheckItemChange,
    tableData,
    init,
    reset,
    search,
    total,
    formData, pagination,headerInfo
} from './index';
import request from "@/service/request";
import {
    exportCityCold,
    exportCityHigh,

} from "@/service/api";
import {download, exportFile} from "@/tool/public";


const  formItems = computed(()=>{
    return [
        {
            prop: "quarter", label: "数据时间", type: 'select', options: headerInfo.value.quarter, placeholder: "请选择"
        },
        {
            prop: "address",
            label: "省/市/区",
            type: 'cascader',
            props: {checkStrictly: true,value:'code',label:'name'},
            placeholder: "请选择",
            options: headerInfo.value.provinces
        },
    ]
})
const cityCascaderProps = {
    checkStrictly: true,
}
const handleCurrentChange  = (val) => {
    pagination.value.pageNum = val
    console.log(pagination.value)
}

const exportInfo = async () => {
    const {address} = formData.value
    let params = {
        ...formData.value,
        provCode: address[0] ? address[0] : '',
        cityCode: address[1] ? address[1] : '',
        areaCode: address[2] ? address[2] : '',
    }
    delete params.address
    // console.log(checkList.value)
    let data = await request({
        url: searchType.value === 'cold' ? exportCityCold :  exportCityHigh,
        method: 'post',
        data: {
            selectedColumns: [...checkList.value],
            ...params,
        },
        download:true,
        responseType: 'blob',
    })
    let str = searchType.value === 'cold'?'冷库城市层级数据':'高标仓城市层级数据'
    exportFile(data,str)
}

onMounted(() => {
    init()
});

</script>
<template>
    <div class="u-agg-box ed-project-box">
        <div class="ed-project-search">
            <div class="ed-project-tabs">
                <a :class="{ 'pt-current': searchType == 'high' }" href="javascript:;"
                   @click="changeSearchType('high')">高标仓</a>
                <a :class="{ 'pt-current': searchType == 'cold' }" href="javascript:;"
                   @click="changeSearchType('cold')">冷库</a>
            </div>
            <div class="ed-project-form">
                <div class="app-search-form">
                    <div v-for="(item,index) in formItems"
                         :class="{'app-sf-no-mr': formItems && index == formItems.length - 1}"
                         class="app-search-fitem">
                        <span>{{ item.label }}：</span>
                        <div class="app-search-ops">
                            <template v-if="item.type == 'input'">
                                <el-input v-model="formData[item.prop]" :placeholder="item.placeholder" size="small"></el-input>
                            </template>
                            <template v-else-if="item.type == 'select'">
                                <el-select v-model="formData[item.prop]" :placeholder="item.placeholder" collapse-tags multiple
                                           size="small">
                                    <el-option v-for="citem in item.options" :key="citem" :label="citem"
                                               :value="citem"></el-option>
                                </el-select>
                            </template>
                            <template v-else-if="item.type == 'cascader'">
                                <el-cascader  v-model="formData[item.prop]" :options="item.options" :placeholder="item.placeholder" :props="item.props"
                                             clearable
                                             size="small"/>
                            </template>

                        </div>
                    </div>
                    <div class="app-search-btns">
                        <el-button size="small" @click="reset">重置</el-button>
                        <el-button size="small" type="primary" @click="search">查询</el-button>
                    </div>
                </div>
            </div>
        </div>
        <div class="ed-project-data">
            <div class="ed-project-atitle">
                <span class="ed-project-titletext">导出字段</span>
                <a href="javascript:;" @click="exportInfo">下载</a>
            </div>
            <div class="ed-project-export-field">
                <el-checkbox v-model="checkAll" class="ed-project-checkall" @change="handleCheckAllChange">全部
                </el-checkbox>
                <el-checkbox-group v-model="checkList" @change="handleCheckItemChange">
                    <el-checkbox v-for="item in checkboxs" :key="item.name" :label="item.name">{{item.text }}</el-checkbox>
                </el-checkbox-group>
            </div>
            <div class="ed-project-table-box">
                <div class="ed-project-table rs-el-table">
                    <el-table :key="searchType" :data="tableData" height="100%" show-overflow-tooltip>
                        <el-table-column
                            v-for="item in checkboxs"
                            :key="item.name"
                            :label="item.text"
                            :prop="item.name"
                            align="center"/>
                    </el-table>
                </div>
                <div class="ed-project-pagination">
                    <el-pagination
                        :total="total"
                        background
                        :page-size="pagination.pageSize"
                        layout="prev, pager, next, jumper"
                        small
                        @current-change="handleCurrentChange"
                    />
                </div>
            </div>

        </div>
    </div>
</template>
<style>@import "../../../assets/css/public.less";
@import "../index.less";</style>